// src/generated.ts
import { z } from "zod";
import { ApplicantDocUploadRequestSchema, DocumentSchema } from "platform-lib/fe-safe";
var Schemas = {
  ApplicantDocUploadRequestSchema,
  DocumentSchema
};
var ApiValidationError = class extends Error {
  constructor(message, fields, details) {
    super(message);
    this.fields = fields;
    this.details = details;
    this.name = "ApiValidationError";
    Object.defineProperty(this, "stack", {
      get: () => `${this.name}: ${this.message}`,
      configurable: true
    });
  }
  // Override toString to show only the message without stack
  toString() {
    return `${this.name}: ${this.message}`;
  }
  // Provide clean JSON serialization
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      fields: this.fields,
      details: this.details
    };
  }
};
function formatZodError(error, context) {
  const formattedErrors = error.format();
  const fields = {};
  const details = [];
  for (const [field, fieldError] of Object.entries(formattedErrors)) {
    if (field !== "_errors" && typeof fieldError === "object" && fieldError !== null && "_errors" in fieldError) {
      const errors = fieldError._errors;
      fields[field] = errors;
      errors.forEach((msg) => {
        details.push(`${field}: ${msg}`);
      });
    }
  }
  if (formattedErrors._errors && formattedErrors._errors.length > 0) {
    formattedErrors._errors.forEach((msg) => {
      details.push(msg);
    });
  }
  const fieldCount = Object.keys(fields).length;
  const missingOrInvalidFields = Object.keys(fields).join(", ");
  let message = `Validation failed for ${context}.`;
  if (fieldCount > 0) {
    message += ` The following field${fieldCount > 1 ? "s are" : " is"} missing or invalid: ${missingOrInvalidFields}`;
  }
  return { message, fields, details };
}
var globalFetchConfig;
function configureFetch(config) {
  globalFetchConfig = config;
}
function makeRequest(method, url, body, options) {
  if (!globalFetchConfig) {
    throw new Error("API client not configured. Call configureFetch() before making requests.");
  }
  const fullUrl = globalFetchConfig.baseUrl ? globalFetchConfig.baseUrl + url : url;
  return globalFetchConfig.fetch(method, fullUrl, body, options);
}
function buildQueryString(params) {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === void 0 || value === null) continue;
    if (Array.isArray(value)) {
      if (value.length === 0) continue;
      for (const item of value) {
        if (item !== void 0 && item !== null) {
          searchParams.append(key, String(item));
        }
      }
    } else {
      searchParams.append(key, String(value));
    }
  }
  return searchParams.toString();
}
var ApiClient = {
  Unsubscribe: {
    /**
     * POST /unsubscribe
     * @returns Promise<ApiResponse<APIResponse>>
     */
    unsubscribe: (() => {
      const method = "POST";
      const path = "/unsubscribe";
      const buildUrl = () => "/unsubscribe";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  UpdateMessages: {
    /**
     * POST /messages
     * @returns Promise<ApiResponse<IMessage>>
     */
    messages: (() => {
      const method = "POST";
      const path = "/messages";
      const buildUrl = () => "/messages";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })()
  },
  Student: {
    Messages: {
      /**
       * POST /messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<IMessage>>
       */
      send: (() => {
        const method = "POST";
        const path = "/messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/messages/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      read: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markRead";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      unread: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/messages/markUnread";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    RecordedInterview: {
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<{ [key: string]: Omit<IRecordedInterviewEntry, 'questions' | 'hasMismatchedQuestions'> } | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews-check
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      check: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews-check";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews-check";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      regenerateScores: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/scores";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<RecordedInterviewResponse>>
       */
      questions: (() => {
        const method = "GET";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/questions";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId ?? validated.INTERVIEWID ?? validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      editScores: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/edit-scores";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment
       * @pathParams {uni: string, studentNo: string, interviewId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      assessment: (() => {
        const method = "POST";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/assessment";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}
       * @pathParams {uni: string, studentNo: string, interviewId: string, videoId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      processing: (() => {
        const method = "GET";
        const path = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), interviewId: z.string(), videoId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/interviews/{uni}/{studentNo}/recorded-interviews/{interviewId}/processing/{videoId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{interviewId}", encodeURIComponent(String(validated.interviewId)));
            url = url.replace("{videoId}", encodeURIComponent(String(validated.videoId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Offer: {
      DownloadAll: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/download
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @body z.object({ includeHidden: z.boolean().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const bodySchema = z.object({ includeHidden: z.boolean().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * GET /student/{uni}/{studentNo}/{intakeId}/{offerId}/download
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/download";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Finance: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/finance
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      VisaPrep: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      FinanceDocument: {
        /**
         * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        noDoc: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/noDoc";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        replaced: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/replace";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        updateStatus: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/update-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        requestCustom: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs/customRequest";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      FollowUpDocument: {
        /**
         * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        updateStatus: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/update-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        requestCustom: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs/customRequest";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Risks: {
        /**
         * PUT /student/{uni}/{studentNo}/{intakeId}/{offerId}/risks
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        put: (() => {
          const method = "PUT";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/risks";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/risks";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CalendlyInterview: {
        Doc: {
          /**
           * DELETE /student/{uni}/{studentNo}/scheduled-interview/doc
           * @pathParams {uni: string, studentNo: string}
           * @body z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })])
           * @returns Promise<ApiResponse<APIResponse>>
           */
          delete: (() => {
            const method = "DELETE";
            const path = "/student/{uni}/{studentNo}/scheduled-interview/doc";
            const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
            const bodySchema = z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })]);
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/student/{uni}/{studentNo}/scheduled-interview/doc";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
                return url;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })(),
          /**
           * POST /student/{uni}/{studentNo}/scheduled-interview/doc
           * @pathParams {uni: string, studentNo: string}
           * @body z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })])
           * @returns Promise<ApiResponse<APIResponse>>
           */
          post: (() => {
            const method = "POST";
            const path = "/student/{uni}/{studentNo}/scheduled-interview/doc";
            const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
            const bodySchema = z.union([z.object({ eventName: z.string(), interviewType: z.string(), eventType: z.string(), eventKey: z.string(), fileNames: z.array(z.string()) }), z.object({ interviewType: z.string(), eventType: z.string(), eventKey: z.string(), deletedFileName: z.string(), uploadedBy: z.string() })]);
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/student/{uni}/{studentNo}/scheduled-interview/doc";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
                return url;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/pass
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventName: z.string(), eventKey: z.string(), status: z.enum(['PASSED', 'FAILED', 'RESIT', 'DELETED']).optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        pass: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/pass";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
          const bodySchema = z.object({ eventType: z.string(), eventName: z.string(), eventKey: z.string(), status: z.enum(["PASSED", "FAILED", "RESIT", "DELETED"]).optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/pass";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/resit
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        resit: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/resit";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
          const bodySchema = z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/resit";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/fail
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        fail: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/fail";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
          const bodySchema = z.object({ eventType: z.string(), eventKey: z.string(), eventName: z.string(), note: z.string(), undo: z.boolean().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/fail";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/request
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.object({ id: z.string().nullable(), schedulingUrl: z.string().optional(), name: z.string().optional(), description: z.string().optional() }), note: z.string().optional() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        request: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/request";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
          const bodySchema = z.object({ eventType: z.object({ id: z.string().nullable(), schedulingUrl: z.string().optional(), name: z.string().optional(), description: z.string().optional() }), note: z.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/request";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/scheduled-interview/cancel
         * @pathParams {uni: string, studentNo: string}
         * @body z.object({ eventType: z.string(), eventKey: z.string(), note: z.string() })
         * @returns Promise<ApiResponse<APIResponse>>
         */
        cancel: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/scheduled-interview/cancel";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
          const bodySchema = z.object({ eventType: z.string(), eventKey: z.string(), note: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/scheduled-interview/cancel";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      },
      RecordedInterview: {
        /**
         * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        request: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/request";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        pass: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/pass";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        resit: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/resit";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        fail: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/fail";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        cancel: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/cancel";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<{ interviews: Record<string, IRecordedInterviewEntry> }>>
         */
        exceeded: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview/exceeded";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CredibilityInterview: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        reset: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview/reset";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/interview
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      OfferEvidence: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/offer-evidence";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      VisaStatus: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Conflict: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-conflict";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Agents: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/agents
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        post: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/agents";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/agents";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      TravelStatus: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/travel-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      AccomodationStatus: {
        /**
         * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status
         * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        update: (() => {
          const method = "POST";
          const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status";
          const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/enrolment-status/accommodation-status";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
              url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
              url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      visaSupport: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/visa-support";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * GET /student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      interviewImages: (() => {
        const method = "GET";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/interview-images";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      updateUniStudentNo: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/uni-student-number";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      updateStatus: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/update-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ActiveOffers: {
      /**
       * GET /student/{uni}/{studentNo}/active-offers
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<Array<IActiveOffer>>>
       */
      get: (() => {
        const method = "GET";
        const path = "/student/{uni}/{studentNo}/active-offers";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/active-offers";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/active-offers
       * @pathParams {uni: string, studentNo: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/active-offers";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/active-offers";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Document: {
      /**
       * DELETE /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      noDoc: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/noDoc";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      applied: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/applied";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      replaced: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/replace";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      updateStatus: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/update-status";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      requestCustom: (() => {
        const method = "POST";
        const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}/docs/customRequest";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * GET /visaStatusUpdate
     * @returns Promise<ApiResponse<unknown>>
     */
    visaStatus: (() => {
      const method = "GET";
      const path = "/visaStatusUpdate";
      const buildUrl = () => "/visaStatusUpdate";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * GET /confirmArrival
     * @returns Promise<ApiResponse<unknown>>
     */
    confirmArrival: (() => {
      const method = "GET";
      const path = "/confirmArrival";
      const buildUrl = () => "/confirmArrival";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * DELETE /student/{uni}/{studentNo}/importHash
     * @pathParams {uni: string, studentNo: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    importHashClear: (() => {
      const method = "DELETE";
      const path = "/student/{uni}/{studentNo}/importHash";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/student/{uni}/{studentNo}/importHash";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /transfer-mate/update-status/{uni}
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    transferMate: (() => {
      const method = "POST";
      const path = "/transfer-mate/update-status/{uni}";
      const pathParamsSchema = z.object({ uni: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/transfer-mate/update-status/{uni}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * PUT /student/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    changeStudentNo: (() => {
      const method = "PUT";
      const path = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/student/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<GetStudentResponse>>
     */
    get: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentAuditResponse>>
     */
    audit: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/audit";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentDocsResponse>>
     */
    docs: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentFinDocsResponse>>
     */
    finDocs: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentFollowUpDocsResponse>>
     */
    followUpDocs: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/follow-up-docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentMessagesResponse>>
     */
    messages: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/messages";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentEmailsResponse>>
     */
    emails: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/emails";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentRecordedInterviewResponse>>
     */
    recordedInterview: (() => {
      const method = "GET";
      const path = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/get-student/{uni}/{studentNo}/{intakeId}/{offerId}/recorded-interview";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  Upload: {
    /**
     * POST /upload-url
     * @body z.object({ id: z.string().optional(), university: z.string().optional(), fileName: z.string(), fileType: z.string(), sponsorType: z.string().nullable().optional(), sponsorKey: z.string().nullable().optional(), docType: z.string().nullable().optional(), docKey: z.string().optional(), interviewType: z.string().optional(), eventType: z.string().optional(), eventKey: z.string().optional(), interviewHash: z.string().optional(), attemptHash: z.string().optional() })
     * @returns Promise<ApiResponse<string>>
     */
    getPresignedUrl: (() => {
      const method = "POST";
      const path = "/upload-url";
      const bodySchema = z.object({ id: z.string().optional(), university: z.string().optional(), fileName: z.string(), fileType: z.string(), sponsorType: z.string().nullable().optional(), sponsorKey: z.string().nullable().optional(), docType: z.string().nullable().optional(), docKey: z.string().optional(), interviewType: z.string().optional(), eventType: z.string().optional(), eventKey: z.string().optional(), interviewHash: z.string().optional(), attemptHash: z.string().optional() });
      const buildUrl = () => "/upload-url";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        try {
          const validatedBody = bodySchema.parse(args.body);
          return makeRequest(method, url, validatedBody, args.options);
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "request body");
            console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      return Object.assign(fn, {
        method,
        path,
        bodySchema,
        buildUrl
      });
    })()
  },
  EgressManager: {
    UniStudent: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudentChat: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/chat";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudentDocs: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    DocsApproved: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/docs/approved";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    StudentAudit: {
      /**
       * GET /uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit
       * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
       * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
       */
      get: (() => {
        const method = "GET";
        const path = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit";
        const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/uni/{uni}/student/{studentNo}/{intakeId}/{offerId}/audit";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
            url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
            url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    SitsPing: {
      /**
       * GET /sits/ping
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/sits/ping";
        const buildUrl = () => "/sits/ping";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    },
    OutboundRetry: {
      /**
       * GET /deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry
       * @pathParams {integration: string, uni: string, userId: string, deliverySortKey: string}
       * @returns Promise<ApiResponse<unknown>>
       */
      get: (() => {
        const method = "GET";
        const path = "/deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry";
        const pathParamsSchema = z.object({ integration: z.string(), uni: z.string(), userId: z.string(), deliverySortKey: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/deliveries/{integration}/{uni}/{userId}/outbound/{deliverySortKey}/retry";
            url = url.replace("{integration}", encodeURIComponent(String(validated.integration)));
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{userId}", encodeURIComponent(String(validated.userId)));
            url = url.replace("{deliverySortKey}", encodeURIComponent(String(validated.deliverySortKey)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * GET /student/{studentNo}/{intakeId}/{offerId}
     * @pathParams {studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<APIResponse & { headers: Record<string, unknown> }>>
     */
    student: (() => {
      const method = "GET";
      const path = "/student/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z.object({ studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/student/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  Integration: {
    Applicants: {
      ResolveDuplicate: {
        /**
         * POST /deliveries/{integration}/applicants/resolve-duplicate
         * @pathParams {integration: string}
         * @body z.object({ uni: z.string(), applicationId: z.string(), userId: z.string(), isDuplicate: z.boolean(), studentNo: z.string().optional() })
         * @returns Promise<ApiResponse<APIResponse<ResolveDuplicateHandlerResponse>>>
         */
        post: (() => {
          const method = "POST";
          const path = "/deliveries/{integration}/applicants/resolve-duplicate";
          const pathParamsSchema = z.object({ integration: z.enum(["oracle", "sits", "ellucian"]) });
          const bodySchema = z.object({ uni: z.string(), applicationId: z.string(), userId: z.string(), isDuplicate: z.boolean(), studentNo: z.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/deliveries/{integration}/applicants/resolve-duplicate";
              url = url.replace("{integration}", encodeURIComponent(String(validated.integration ?? validated.INTEGRATION ?? validated.integration)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            try {
              const validatedBody = bodySchema.parse(args.body);
              return makeRequest(method, url, validatedBody, args.options);
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "request body");
                console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            bodySchema,
            buildUrl
          });
        })()
      }
    }
  },
  MeetingManager: {
    CalendlyWebhooks: {
      /**
       * POST /calendly/webhooks
       * @returns Promise<ApiResponse<void>>
       */
      post: (() => {
        const method = "POST";
        const path = "/calendly/webhooks";
        const buildUrl = () => "/calendly/webhooks";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          buildUrl
        });
      })()
    }
  },
  Config: {
    ScheduledInterviews: {
      Uni: {
        EventTypes: {
          /**
           * GET /event-types/{uni}
           * @pathParams {uni: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          get: (() => {
            const method = "GET";
            const path = "/event-types/{uni}";
            const pathParamsSchema = z.object({ uni: z.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/event-types/{uni}";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                return url;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        },
        Config: {
          /**
           * POST /calendly-auth/config/{uni}
           * @pathParams {uni: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          update: (() => {
            const method = "POST";
            const path = "/calendly-auth/config/{uni}";
            const pathParamsSchema = z.object({ uni: z.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/calendly-auth/config/{uni}";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                return url;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        }
      },
      Pathway: {
        EventTypes: {
          /**
           * GET /event-types/{uni}/pathway/{pathway}
           * @pathParams {uni: string, pathway: string}
           * @returns Promise<ApiResponse<APIResponse>>
           */
          get: (() => {
            const method = "GET";
            const path = "/event-types/{uni}/pathway/{pathway}";
            const pathParamsSchema = z.object({ uni: z.string(), pathway: z.string() });
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/event-types/{uni}/pathway/{pathway}";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
                url = url.replace("{pathway}", encodeURIComponent(String(validated.pathway)));
                return url;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              return makeRequest(method, url, args.body, args.options);
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              buildUrl
            });
          })()
        }
      }
    },
    Uni: {
      RegionOffices: {
        /**
         * GET /offices/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionOffice[]>>
         */
        list: (() => {
          const method = "GET";
          const path = "/offices/{uni}";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RegionOffice: {
        /**
         * GET /offices/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionOffice>>
         */
        get: (() => {
          const method = "GET";
          const path = "/offices/{uni}/{id}";
          const pathParamsSchema = z.object({ uni: z.string(), id: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /offices/{uni}
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<IRegionOffice>>
         */
        create: (() => {
          const method = "POST";
          const path = "/offices/{uni}";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * PUT /offices/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<IRegionOffice>>
         */
        update: (() => {
          const method = "PUT";
          const path = "/offices/{uni}/{id}";
          const pathParamsSchema = z.object({ uni: z.string(), id: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * DELETE /offices/{uni}/{id}
         * @pathParams {uni: string, id: string}
         * @returns Promise<ApiResponse<void>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/offices/{uni}/{id}";
          const pathParamsSchema = z.object({ uni: z.string(), id: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/offices/{uni}/{id}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{id}", encodeURIComponent(String(validated.id ?? validated.ID ?? validated.id)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    }
  },
  Apply: {
    CalendlyInterview: {
      SchedulingInfo: {
        /**
         * GET /event-types/{uni}/{eventTypeUuid}/scheduling-info
         * @pathParams {uni: string, eventTypeUuid: string}
         * @returns Promise<ApiResponse<SchedulingInfoResponse | GetErrorResponse>>
         */
        get: (() => {
          const method = "GET";
          const path = "/event-types/{uni}/{eventTypeUuid}/scheduling-info";
          const pathParamsSchema = z.object({ uni: z.string(), eventTypeUuid: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/event-types/{uni}/{eventTypeUuid}/scheduling-info";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{eventTypeUuid}", encodeURIComponent(String(validated.eventTypeUuid ?? validated.EVENTTYPEUUID ?? validated.eventTypeUuid)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    }
  },
  DocumentManager: {
    DocumentsCountPerType: {
      /**
       * GET /documents/count-per-type
       * @body z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() })
       * @returns Promise<ApiResponse<GetCountPerDocumentTypeResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/documents/count-per-type";
        const bodySchema = z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() });
        const buildUrl = () => "/documents/count-per-type";
        const fn = async (args) => {
          let url = buildUrl();
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          bodySchema,
          buildUrl
        });
      })()
    },
    ApplicantUpload: {
      /**
       * POST /documents/{uni}/applicant/{applicantId}/upload
       * @pathParams {uni: string, applicantId: string}
       * @body ApplicantDocUploadRequestSchema
       * @returns Promise<ApiResponse<DocumentPresignedUrlResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/documents/{uni}/applicant/{applicantId}/upload";
        const pathParamsSchema = z.object({ uni: z.string(), applicantId: z.string() });
        const bodySchema = ApplicantDocUploadRequestSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/upload";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    Applicant: {
      Staff: {
        UploadUrl: {
          /**
           * POST /documents/{uni}/applicant/{applicantId}/staff
           * @pathParams {uni: string, applicantId: string}
           * @body ApplicantDocUploadRequestSchema
           * @returns Promise<ApiResponse<DocumentPresignedUrlResponse | ErrorResponse>>
           */
          post: (() => {
            const method = "POST";
            const path = "/documents/{uni}/applicant/{applicantId}/staff";
            const pathParamsSchema = z.object({ uni: z.string(), applicantId: z.string() });
            const bodySchema = ApplicantDocUploadRequestSchema;
            const buildUrl = (params) => {
              try {
                const validated = pathParamsSchema.parse(params);
                let url = "/documents/{uni}/applicant/{applicantId}/staff";
                url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
                url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
                return url;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "path parameters");
                  console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            const fn = async (args) => {
              let url = buildUrl(args.pathParams);
              if (args.queryParams) {
                const queryString = buildQueryString(args.queryParams);
                if (queryString) url += "?" + queryString;
              }
              try {
                const validatedBody = bodySchema.parse(args.body);
                return makeRequest(method, url, validatedBody, args.options);
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "request body");
                  console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            };
            return Object.assign(fn, {
              method,
              path,
              pathParamsSchema,
              bodySchema,
              buildUrl
            });
          })()
        },
        /**
         * DELETE /documents/{uni}/applicant/{applicantId}/staff/{docKey}
         * @pathParams {uni: string, applicantId: string, docKey: string}
         * @queryParams z.object({ s3Key: z.string().optional() })
         * @returns Promise<ApiResponse<DeleteStaffInternalDocumentResponse | ErrorResponse>>
         */
        delete: (() => {
          const method = "DELETE";
          const path = "/documents/{uni}/applicant/{applicantId}/staff/{docKey}";
          const pathParamsSchema = z.object({ uni: z.string(), applicantId: z.string(), docKey: z.string().optional() });
          const queryParamsSchema = z.object({ s3Key: z.string().optional() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/documents/{uni}/applicant/{applicantId}/staff/{docKey}";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
              url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
              url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              try {
                const validatedQuery = queryParamsSchema.parse(args.queryParams);
                const queryString = buildQueryString(validatedQuery);
                if (queryString) url += "?" + queryString;
              } catch (error) {
                if (error instanceof z.ZodError) {
                  const formatted = formatZodError(error, "query parameters");
                  console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
                  throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
                }
                throw error;
              }
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            queryParamsSchema,
            buildUrl
          });
        })()
      }
    },
    DocumentsApplicant: {
      /**
       * GET /documents/{uni}/applicant/{applicantId}/{docType}
       * @pathParams {uni: string, applicantId: string, docType: string}
       * @body z.object({ status: z.enum(['AWAITING', 'UPLOADED_OK', 'UPLOADED_WITH_ERROR', 'REJECTED', 'REJECTED_WITHOUT_ALTERNATIVE', 'APPROVED', 'REPLACED', 'DELETED', 'SKIPPED', 'INFO_ONLY', 'NOT_ACKNOWLEDGED', 'ACKNOWLEDGED']), label: z.string(), fileNames: z.array(z.string()), prevStatus: z.enum(['AWAITING', 'UPLOADED_OK', 'UPLOADED_WITH_ERROR', 'REJECTED', 'REJECTED_WITHOUT_ALTERNATIVE', 'APPROVED', 'REPLACED', 'DELETED', 'SKIPPED', 'INFO_ONLY', 'NOT_ACKNOWLEDGED', 'ACKNOWLEDGED']).optional(), files: z.array(z.object({ label: z.string(), fileName: z.string(), isPdfFile: z.boolean().optional(), noOfPages: z.number().optional(), isProcessing: z.boolean().optional(), fileSize: z.number().optional(), fileType: z.string().optional(), s3Key: z.string().optional() })), reason: z.string().optional(), signedUrls: z.array(z.string()).optional(), uploadedBy: z.enum(['', 'Admin', 'Agent', 'University', 'Enroly', 'SITS']).optional(), userAccess: z.enum(['STAFF_ONLY', 'AGENT_ONLY']).optional(), isProcessingPdf: z.boolean().optional(), eTags: z.array(z.string()).optional(), s3Keys: z.array(z.string()).optional(), fileLabels: z.array(z.string()).optional(), deletedByTTL: z.boolean().optional() })
       * @returns Promise<ApiResponse<GetDocumentsListResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/documents/{uni}/applicant/{applicantId}/{docType}";
        const pathParamsSchema = z.object({ docType: z.string(), uni: z.string().optional(), applicantId: z.string().optional() });
        const bodySchema = z.object({ status: z.enum(["AWAITING", "UPLOADED_OK", "UPLOADED_WITH_ERROR", "REJECTED", "REJECTED_WITHOUT_ALTERNATIVE", "APPROVED", "REPLACED", "DELETED", "SKIPPED", "INFO_ONLY", "NOT_ACKNOWLEDGED", "ACKNOWLEDGED"]), label: z.string(), fileNames: z.array(z.string()), prevStatus: z.enum(["AWAITING", "UPLOADED_OK", "UPLOADED_WITH_ERROR", "REJECTED", "REJECTED_WITHOUT_ALTERNATIVE", "APPROVED", "REPLACED", "DELETED", "SKIPPED", "INFO_ONLY", "NOT_ACKNOWLEDGED", "ACKNOWLEDGED"]).optional(), files: z.array(z.object({ label: z.string(), fileName: z.string(), isPdfFile: z.boolean().optional(), noOfPages: z.number().optional(), isProcessing: z.boolean().optional(), fileSize: z.number().optional(), fileType: z.string().optional(), s3Key: z.string().optional() })), reason: z.string().optional(), signedUrls: z.array(z.string()).optional(), uploadedBy: z.enum(["", "Admin", "Agent", "University", "Enroly", "SITS"]).optional(), userAccess: z.enum(["STAFF_ONLY", "AGENT_ONLY"]).optional(), isProcessingPdf: z.boolean().optional(), eTags: z.array(z.string()).optional(), s3Keys: z.array(z.string()).optional(), fileLabels: z.array(z.string()).optional(), deletedByTTL: z.boolean().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/{docType}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * POST /documents/{uni}/applicant/{applicantId}/{docType}/{docKey}
       * @pathParams {uni: string, applicantId: string, docType: string, docKey: string}
       * @body DocumentSchema
       * @returns Promise<ApiResponse<PostDocumentResponse | ErrorResponse>>
       */
      post: (() => {
        const method = "POST";
        const path = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
        const pathParamsSchema = z.object({ docType: z.string(), docKey: z.string() });
        const bodySchema = DocumentSchema;
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
            url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })(),
      /**
       * DELETE /documents/{uni}/applicant/{applicantId}/{docType}/{docKey}
       * @pathParams {uni: string, applicantId: string, docType: string, docKey: string}
       * @returns Promise<ApiResponse<APIResponse | ErrorResponse>>
       */
      delete: (() => {
        const method = "DELETE";
        const path = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
        const pathParamsSchema = z.object({ docType: z.string(), docKey: z.string(), uni: z.string().optional(), applicantId: z.string().optional() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/{docType}/{docKey}";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId ?? validated.APPLICANTID ?? validated.applicantId)));
            url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
            url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    ApplicantCountPerType: {
      /**
       * GET /documents/{uni}/applicant/{applicantId}/count-per-type
       * @pathParams {uni: string, applicantId: string}
       * @body z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() })
       * @returns Promise<ApiResponse<GetCountPerDocumentTypeResponse>>
       */
      get: (() => {
        const method = "GET";
        const path = "/documents/{uni}/applicant/{applicantId}/count-per-type";
        const pathParamsSchema = z.object({ uni: z.string(), applicantId: z.string() });
        const bodySchema = z.object({ academicTranscript: z.number(), passport: z.number(), personalStatement: z.number(), photoId: z.number(), cv: z.number(), englishTest: z.number(), referenceLetter: z.number(), academicCertificate: z.number(), proofOfAddress: z.number(), proofOfNameChange: z.number(), nameAffidavit: z.number(), birthCert: z.number(), proofOfImmigrationStatus: z.number(), proofOfManagerialExperience: z.number(), proofOfPayment: z.number(), portfolio: z.number(), researchProposal: z.number(), customRequest: z.number(), customRequirement: z.number(), staffDocument: z.number(), staffOnlyRequirement: z.number() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/documents/{uni}/applicant/{applicantId}/count-per-type";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            url = url.replace("{applicantId}", encodeURIComponent(String(validated.applicantId)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          try {
            const validatedBody = bodySchema.parse(args.body);
            return makeRequest(method, url, validatedBody, args.options);
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "request body");
              console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          bodySchema,
          buildUrl
        });
      })()
    },
    /**
     * DELETE /documents/{docType}/{docKey}
     * @pathParams {docType: string, docKey: string}
     * @returns Promise<ApiResponse<APIResponse | ErrorResponse>>
     */
    documents: (() => {
      const method = "DELETE";
      const path = "/documents/{docType}/{docKey}";
      const pathParamsSchema = z.object({ docType: z.string(), docKey: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/documents/{docType}/{docKey}";
          url = url.replace("{docType}", encodeURIComponent(String(validated.docType ?? validated.DOCTYPE ?? validated.docType)));
          url = url.replace("{docKey}", encodeURIComponent(String(validated.docKey ?? validated.DOCKEY ?? validated.docKey)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  },
  Students: {
    BulkChange: {
      Stage: {
        /**
         * POST /students/{uni}/bulk-action/stage
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        assign: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/stage";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/stage";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      ImmigrationProvider: {
        /**
         * POST /students/{uni}/bulk-action/immigration-provider
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        assign: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/immigration-provider";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/immigration-provider";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      RecordedInterview: {
        /**
         * POST /students/{uni}/bulk-action/recorded-interview/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/recorded-interview/remove";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/recorded-interview/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/recorded-interview/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/recorded-interview/add";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/recorded-interview/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      CalendlyInterview: {
        /**
         * POST /students/{uni}/bulk-action/scheduled-interview/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/scheduled-interview/remove";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/scheduled-interview/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/scheduled-interview/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/scheduled-interview/add";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/scheduled-interview/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Tags: {
        /**
         * POST /students/{uni}/bulk-action/tags/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/tags/add";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/tags/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/tags/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/tags/remove";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/tags/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/tags/pin
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        pin: (() => {
          const method = "POST";
          const path = "/students/{uni}/tags/pin";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/tags/pin";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/tags/unpin
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        unpin: (() => {
          const method = "POST";
          const path = "/students/{uni}/tags/unpin";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/tags/unpin";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      },
      Partners: {
        /**
         * POST /students/{uni}/bulk-action/partners/add
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        add: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/partners/add";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/partners/add";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })(),
        /**
         * POST /students/{uni}/bulk-action/partners/remove
         * @pathParams {uni: string}
         * @returns Promise<ApiResponse<APIResponse>>
         */
        remove: (() => {
          const method = "POST";
          const path = "/students/{uni}/bulk-action/partners/remove";
          const pathParamsSchema = z.object({ uni: z.string() });
          const buildUrl = (params) => {
            try {
              const validated = pathParamsSchema.parse(params);
              let url = "/students/{uni}/bulk-action/partners/remove";
              url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
              return url;
            } catch (error) {
              if (error instanceof z.ZodError) {
                const formatted = formatZodError(error, "path parameters");
                console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
                throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
              }
              throw error;
            }
          };
          const fn = async (args) => {
            let url = buildUrl(args.pathParams);
            if (args.queryParams) {
              const queryString = buildQueryString(args.queryParams);
              if (queryString) url += "?" + queryString;
            }
            return makeRequest(method, url, args.body, args.options);
          };
          return Object.assign(fn, {
            method,
            path,
            pathParamsSchema,
            buildUrl
          });
        })()
      }
    },
    ImmigrationProvider: {
      /**
       * POST /students/{uni}/immigration-provider/update
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      update: (() => {
        const method = "POST";
        const path = "/students/{uni}/immigration-provider/update";
        const pathParamsSchema = z.object({ uni: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/immigration-provider/update";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /students/{uni}/immigration-provider/remove
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      remove: (() => {
        const method = "POST";
        const path = "/students/{uni}/immigration-provider/remove";
        const pathParamsSchema = z.object({ uni: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/immigration-provider/remove";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    Partners: {
      /**
       * POST /students/{uni}/partners/add
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      add: (() => {
        const method = "POST";
        const path = "/students/{uni}/partners/add";
        const pathParamsSchema = z.object({ uni: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/partners/add";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })(),
      /**
       * POST /students/{uni}/partners/remove
       * @pathParams {uni: string}
       * @returns Promise<ApiResponse<APIResponse>>
       */
      remove: (() => {
        const method = "POST";
        const path = "/students/{uni}/partners/remove";
        const pathParamsSchema = z.object({ uni: z.string() });
        const buildUrl = (params) => {
          try {
            const validated = pathParamsSchema.parse(params);
            let url = "/students/{uni}/partners/remove";
            url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
            return url;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "path parameters");
              console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        };
        const fn = async (args) => {
          let url = buildUrl(args.pathParams);
          if (args.queryParams) {
            const queryString = buildQueryString(args.queryParams);
            if (queryString) url += "?" + queryString;
          }
          return makeRequest(method, url, args.body, args.options);
        };
        return Object.assign(fn, {
          method,
          path,
          pathParamsSchema,
          buildUrl
        });
      })()
    },
    /**
     * POST /students/bulkChange
     * @returns Promise<ApiResponse<APIResponse>>
     */
    bulkChange: (() => {
      const method = "POST";
      const path = "/students/bulkChange";
      const buildUrl = () => "/students/bulkChange";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/reset-import-hashes
     * @pathParams {uni: string}
     * @returns Promise<ApiResponse<APIResponse>>
     */
    importHashesReset: (() => {
      const method = "POST";
      const path = "/students/{uni}/reset-import-hashes";
      const pathParamsSchema = z.object({ uni: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/reset-import-hashes";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students
     * @queryParams z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(['asc', 'desc']).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() })
     * @returns Promise<ApiResponse<GetStudentsResponse>>
     */
    list: (() => {
      const method = "GET";
      const path = "/get-students";
      const queryParamsSchema = z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(["asc", "desc"]).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() });
      const buildUrl = () => "/get-students";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students/totals
     * @queryParams z.object({ uni: z.string(), intakeId: z.string().optional() })
     * @returns Promise<ApiResponse<StudentTotalsResponse>>
     */
    totals: (() => {
      const method = "GET";
      const path = "/get-students/totals";
      const queryParamsSchema = z.object({ uni: z.string(), intakeId: z.string().optional() });
      const buildUrl = () => "/get-students/totals";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students/filters
     * @queryParams z.object({ uni: z.string(), intakeId: z.string().optional() })
     * @returns Promise<ApiResponse<StudentFiltersResponse>>
     */
    filters: (() => {
      const method = "GET";
      const path = "/get-students/filters";
      const queryParamsSchema = z.object({ uni: z.string(), intakeId: z.string().optional() });
      const buildUrl = () => "/get-students/filters";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /get-students/ids
     * @queryParams z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(['asc', 'desc']).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() })
     * @returns Promise<ApiResponse<StudentIdsResponse>>
     */
    ids: (() => {
      const method = "GET";
      const path = "/get-students/ids";
      const queryParamsSchema = z.object({ uni: z.string().optional(), intakeId: z.string().optional(), pathway: z.string().optional(), stage: z.string().optional(), limit: z.number().optional(), offset: z.number().optional(), sortBy: z.string().optional(), sortOrder: z.enum(["asc", "desc"]).optional(), search: z.string().optional(), pathwayVisibility: z.string().optional(), message: z.boolean().optional(), startDate: z.string().optional(), endDate: z.string().optional(), unis: z.unknown().optional(), studentNo: z.unknown().optional(), givenName: z.unknown().optional(), surname: z.unknown().optional(), course: z.unknown().optional(), faculty: z.unknown().optional(), nationality: z.unknown().optional(), country: z.unknown().optional(), applicationCountry: z.unknown().optional(), activityStatus: z.unknown().optional(), notStarted: z.unknown().optional(), idle: z.unknown().optional(), complete: z.unknown().optional(), incomplete: z.unknown().optional(), fundsMaturity: z.unknown().optional(), market: z.unknown().optional(), region: z.unknown().optional(), visaStatus: z.unknown().optional(), confidence: z.unknown().optional(), agent: z.unknown().optional(), conditionalStatus: z.unknown().optional(), courseConditionalStatus: z.unknown().optional(), courseCondtionalStatus: z.unknown().optional(), evidenceRequirements: z.unknown().optional(), customRegion: z.unknown().optional(), tag: z.unknown().optional(), programmableTag: z.unknown().optional(), services: z.unknown().optional(), immigrationProviders: z.unknown().optional(), interview: z.unknown().optional(), recordedInterview: z.unknown().optional(), idleFrom: z.unknown().optional(), idleTo: z.unknown().optional(), dependants: z.unknown().optional(), tagsMatch: z.unknown().optional(), programmableTagsMatch: z.unknown().optional() });
      const buildUrl = () => "/get-students/ids";
      const fn = async (args) => {
        let url = buildUrl();
        if (args.queryParams) {
          try {
            const validatedQuery = queryParamsSchema.parse(args.queryParams);
            const queryString = buildQueryString(validatedQuery);
            if (queryString) url += "?" + queryString;
          } catch (error) {
            if (error instanceof z.ZodError) {
              const formatted = formatZodError(error, "query parameters");
              console.error("[ApiClient] Query parameter validation failed:", formatted.message, formatted.details);
              throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
            }
            throw error;
          }
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        queryParamsSchema,
        buildUrl
      });
    })()
  },
  StudentPortal: {
    /**
     * GET /students/{uni}/{studentNo}/active-offers
     * @pathParams {uni: string, studentNo: string}
     * @returns Promise<ApiResponse<StudentPortalActiveOffersResponse>>
     */
    activeOffers: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/active-offers";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/active-offers";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/active-offer
     * @pathParams {uni: string, studentNo: string}
     * @body z.object({ intakeId: z.string(), offerId: z.string() })
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    setActiveOffer: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/active-offer";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
      const bodySchema = z.object({ intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/active-offer";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        try {
          const validatedBody = bodySchema.parse(args.body);
          return makeRequest(method, url, validatedBody, args.options);
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "request body");
            console.error("[ApiClient] Request body validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        bodySchema,
        buildUrl
      });
    })(),
    /**
     * GET /students/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<GetStudentResponse>>
     */
    getCas: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateStudent: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /students/{uni}/{studentNo}/{intakeId}/{offerId}/docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentDocsResponse>>
     */
    docs: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * GET /students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<StudentFinDocsResponse>>
     */
    finDocs: (() => {
      const method = "GET";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/fin-docs";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/upload
     * @pathParams {uni: string, studentNo: string}
     * @returns Promise<ApiResponse<UploadPresignedUrlResponse>>
     */
    upload: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/upload";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/upload";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}/finance
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateFinance: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/finance";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateVisaPrep: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-prep";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })(),
    /**
     * POST /students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status
     * @pathParams {uni: string, studentNo: string, intakeId: string, offerId: string}
     * @returns Promise<ApiResponse<SuccessResponse>>
     */
    updateVisaStatus: (() => {
      const method = "POST";
      const path = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
      const pathParamsSchema = z.object({ uni: z.string(), studentNo: z.string(), intakeId: z.string(), offerId: z.string() });
      const buildUrl = (params) => {
        try {
          const validated = pathParamsSchema.parse(params);
          let url = "/students/{uni}/{studentNo}/{intakeId}/{offerId}/visa-status";
          url = url.replace("{uni}", encodeURIComponent(String(validated.uni ?? validated.UNI ?? validated.uni)));
          url = url.replace("{studentNo}", encodeURIComponent(String(validated.studentNo ?? validated.STUDENTNO ?? validated.studentNo)));
          url = url.replace("{intakeId}", encodeURIComponent(String(validated.intakeId ?? validated.INTAKEID ?? validated.intakeId)));
          url = url.replace("{offerId}", encodeURIComponent(String(validated.offerId ?? validated.OFFERID ?? validated.offerId)));
          return url;
        } catch (error) {
          if (error instanceof z.ZodError) {
            const formatted = formatZodError(error, "path parameters");
            console.error("[ApiClient] Path parameter validation failed:", formatted.message, formatted.details);
            throw new ApiValidationError(formatted.message, formatted.fields, formatted.details);
          }
          throw error;
        }
      };
      const fn = async (args) => {
        let url = buildUrl(args.pathParams);
        if (args.queryParams) {
          const queryString = buildQueryString(args.queryParams);
          if (queryString) url += "?" + queryString;
        }
        return makeRequest(method, url, args.body, args.options);
      };
      return Object.assign(fn, {
        method,
        path,
        pathParamsSchema,
        buildUrl
      });
    })()
  }
};

// src/responseTypes.ts
import { ShareCodeStatus } from "cas-lib/fe-safe";
import { AGENT_CONFLICT_SUMMARY_KEYS, AGENT_DETAIL_FIELD_LABELS, AccommodationArrangedStatusEnum, AccommodationTypeStatusEnum, Agent, AgentApplicantAuthorisationStatus, ApiFilterKeys, ApplicantDocUploadRequestSchema as ApplicantDocUploadRequestSchema2, ApplicantOfferConditionType, ApplicantOfferPGFilterMap, ApplicantOfferPaymentStatus, ApplicantOfferRequirement, ApplicantOfferRequirementTask, ApplicantOfferRequirementTaskActionStatus, ApplicantOfferRequirementTaskLevel, ApplicantOfferRequirementTaskStatus, ApplicantOfferResponseStatus, ApplicantOfferStatus, ApplicantStatusReason, ApplicationPGFilterMap, ApplicationRefereeRelation, ApplicationStatus, ApplicationTaskGroupLabel, ApplicationTaskLabel, AppliedAdminReviewStatus, AppliedEUSSStatus, CHANNEL, CoreStatusExtended, CountryCategory, CourseLevel, CourseLevelOfferStatus, CreateApplicantOfferRequirementTaskSchema, DocAccessType, DocStatus, DocStatusType, DocumentType, EApplicantOfferPGKeys, EApplicationPGKeys, EUSSStatus, EmailStatus, EmploymentStatus, EnglishTestType, EntryPoint, EventBookingStatus, EventInfoStatus, EventSystemStatus, FamilySponsorType, FeeStatus, FilterKey, FilterKeyMap, FilterKeyValues, FilterType, FingerStatus, FollowUpDocStatusType, Gender, GenericsIntegration, GradeLevel, GradeSystem, IFollowUpArea, IUserRole, ImportSource, InfoState, InsightsAccessLevel, IntakeStatus, LoanType, LocationType, MfaMethod, OfferStatus, OfferTimelineStageType, OptionStatusType, OrgType, PartnerVisaStatus, Partners, RecordedInterviewAssessmentDecision, RecordedInterviewSystemStatus, RefusalGrounds, RegionConfigType, ResultStatus, SMapMatch, SMapWhen, ScholarshipType, ScoreTypeEnum, SectionLabel, SectionStatusType, StudyLevel, StudyMode, TOPIC, TYPE, TagAction, TagType, TransactionStatus, TravelStatusEnum, UniConfigRequirementTaskFulfilmentMethod, UpdateVisaSupportAction, UserStatus, VisaStatus, WorkflowAccessLevel, Workflows, getServiceProviderType, partnerCodeToServiceProviderType } from "platform-lib/fe-safe";
export {
  AGENT_CONFLICT_SUMMARY_KEYS,
  AGENT_DETAIL_FIELD_LABELS,
  AccommodationArrangedStatusEnum,
  AccommodationTypeStatusEnum,
  Agent,
  AgentApplicantAuthorisationStatus,
  ApiClient,
  ApiFilterKeys,
  ApiValidationError,
  ApplicantDocUploadRequestSchema2 as ApplicantDocUploadRequestSchema,
  ApplicantOfferConditionType,
  ApplicantOfferPGFilterMap,
  ApplicantOfferPaymentStatus,
  ApplicantOfferRequirement,
  ApplicantOfferRequirementTask,
  ApplicantOfferRequirementTaskActionStatus,
  ApplicantOfferRequirementTaskLevel,
  ApplicantOfferRequirementTaskStatus,
  ApplicantOfferResponseStatus,
  ApplicantOfferStatus,
  ApplicantStatusReason,
  ApplicationPGFilterMap,
  ApplicationRefereeRelation,
  ApplicationStatus,
  ApplicationTaskGroupLabel,
  ApplicationTaskLabel,
  AppliedAdminReviewStatus,
  AppliedEUSSStatus,
  CHANNEL,
  CoreStatusExtended,
  CountryCategory,
  CourseLevel,
  CourseLevelOfferStatus,
  CreateApplicantOfferRequirementTaskSchema,
  DocAccessType,
  DocStatus,
  DocStatusType,
  DocumentType,
  EApplicantOfferPGKeys,
  EApplicationPGKeys,
  EUSSStatus,
  EmailStatus,
  EmploymentStatus,
  EnglishTestType,
  EntryPoint,
  EventBookingStatus,
  EventInfoStatus,
  EventSystemStatus,
  FamilySponsorType,
  FeeStatus,
  FilterKey,
  FilterKeyMap,
  FilterKeyValues,
  FilterType,
  FingerStatus,
  FollowUpDocStatusType,
  Gender,
  GenericsIntegration,
  GradeLevel,
  GradeSystem,
  IFollowUpArea,
  IUserRole,
  ImportSource,
  InfoState,
  InsightsAccessLevel,
  IntakeStatus,
  LoanType,
  LocationType,
  MfaMethod,
  OfferStatus,
  OfferTimelineStageType,
  OptionStatusType,
  OrgType,
  PartnerVisaStatus,
  Partners,
  RecordedInterviewAssessmentDecision,
  RecordedInterviewSystemStatus,
  RefusalGrounds,
  RegionConfigType,
  ResultStatus,
  SMapMatch,
  SMapWhen,
  Schemas,
  ScholarshipType,
  ScoreTypeEnum,
  SectionLabel,
  SectionStatusType,
  ShareCodeStatus,
  StudyLevel,
  StudyMode,
  TOPIC,
  TYPE,
  TagAction,
  TagType,
  TransactionStatus,
  TravelStatusEnum,
  UniConfigRequirementTaskFulfilmentMethod,
  UpdateVisaSupportAction,
  UserStatus,
  VisaStatus,
  WorkflowAccessLevel,
  Workflows,
  configureFetch,
  getServiceProviderType,
  partnerCodeToServiceProviderType
};
